module.exports = __webpack_public_path__ + "img/dialog-logo.edca290f.png";